import React from 'react';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover editor; each part uses its own slice of it */
import styles from '../../CoverEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface InspectorRowProps {
  label: string;
  children: React.ReactNode;
}

/** One row of the inspector grid: the name at the left, the control at the right. */
const InspectorRowComponent: React.FC<InspectorRowProps> = ({ label, children }) => (
  <>
    <span className={styles.rowLabel}>{label}</span>
    {children}
  </>
);

export const InspectorRow = TypedMemo(InspectorRowComponent);
